import { render, staticRenderFns } from "./BoxSelector.vue?vue&type=template&id=666fc4da&scoped=true&"
import script from "./BoxSelector.vue?vue&type=script&lang=js&"
export * from "./BoxSelector.vue?vue&type=script&lang=js&"
import style0 from "./BoxSelector.vue?vue&type=style&index=0&id=666fc4da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666fc4da",
  null
  
)

export default component.exports